import React, { useState, useEffect } from 'react'
import { call } from '../Methods'

function HelpAndFaqs () {
  const [content, setContent] = useState('')
  const [loading, setLoading] = useState(true)
  const contentKey = 'Page.helpandfaqs'

  const getData = async () => {
    setLoading(true)
    const _helpAndFaqs = await call.content.getContents({
      fullName: contentKey
    })
    setContent(_helpAndFaqs)
    setLoading(false)
  }
  useEffect(() => {
    getData()
  }, [])

  if (loading) return <div className='loading'>Loading...</div>
  if (!content) return <div className='loading'>Something wrong happen...</div>
  return (
    <>
      <div className='page help-and-faqs-page'>
        <div className='page-content text-content'>
          <div className='page-header'>
            <h1 className='main'>Help and FAQs</h1>
          </div>
          <p className="paragraph" dangerouslySetInnerHTML={{ __html: content.value }}></p>
        </div>
      </div>
    </>
  )
}

export default HelpAndFaqs
